export default __webpack_public_path__ + "static/media/footer-linkedin.0cac4c36.svg";